/**
 * Utility class for Area Indicator operations
 */
class AreaIndicatorUtils {
    /**
     * Gets the minimum and maximum dates from the objectives of an area indicator
     * @param {Object} areaIndicator - The area indicator object
     * @returns {Object|null} Object with minDate and maxDate properties, or null if no objectives
     */
    static getObjectivesDateRange(areaIndicator) {
        if (!areaIndicator || !areaIndicator.objectiveDTOs || areaIndicator.objectiveDTOs.length === 0) {
            return null;
        }

        const dates = [];
        
        // Extract all dates from objectives
        areaIndicator.objectiveDTOs.forEach(objective => {
            if (objective.startDate) {
                dates.push(new Date(objective.startDate));
            }
            if (objective.endDate) {
                dates.push(new Date(objective.endDate));
            }
            // Add other date fields as needed (e.g., createdDate, targetDate, etc.)
        });

        if (dates.length === 0) {
            return null;
        }

        // Sort dates to find min and max
        dates.sort((a, b) => a - b);

        return {
            minDate: dates[0],
            maxDate: dates[dates.length - 1]
        };
    }
    
    /**
     * Checks if an area's date range covers the given min and max dates
     * @param {Object} area - The area object
     * @param {Date} minDate - The minimum date to check coverage for
     * @param {Date} maxDate - The maximum date to check coverage for
     * @returns {boolean} True if the area's dates cover the min/max dates, false otherwise
     */
    static areaDatesCoversRange(area, minDate, maxDate) {
        if (!area || !minDate || !maxDate) {
            return false;
        }

        // Check if area has the necessary date fields
        if (!area.startDate || !area.endDate) {
            return false;
        }

        const areaStartDate = new Date(area.startDate);
        const areaEndDate = new Date(area.endDate);

        // Area covers the range if its start date is <= minDate and its end date is >= maxDate
        return areaStartDate <= minDate && areaEndDate >= maxDate;
    }
}

export default AreaIndicatorUtils;
